import React from 'react'
import PropTypes from 'prop-types'

const AwardsHomepage = React.forwardRef((props, ref) => {
    return (
        <div ref={ref}>
            <img src='/images/awards/exetel-award.svg' alt='Award winning exetel' />
        </div>
    )
})

AwardsHomepage.propTypes = {

}

export default AwardsHomepage



// WEBPACK FOOTER //
// ./resources/js/components/AwardsHomepage.js